/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  actions: {
    type: Array
  },
  author: {
    type: [String, Function]
  },
  avatar: {
    type: [String, Object, Function]
  },
  content: {
    type: [String, Function]
  },
  datetime: {
    type: [String, Function]
  },
  quote: {
    type: [String, Function]
  },
  reply: {
    type: [String, Function]
  }
};

export { props as default };
//# sourceMappingURL=props.mjs.map
